import Modal from './Modal';
import { getShortcutLabel } from '../../hooks/useHotkeys';

const SHORTCUTS = [
  {
    category: 'Navigation',
    items: [
      { keys: 'mod+k', description: 'Open command palette' },
      { keys: 'mod+/', description: 'Show keyboard shortcuts' },
      { keys: '/', description: 'Jump to report (on Reports pages)' },
    ],
  },
  {
    category: 'Actions',
    items: [
      { keys: 'mod+s', description: 'Save current form (when available)' },
      { keys: 'mod+n', description: 'New document (when available)' },
      { keys: 'mod+shift+n', description: 'Open notification center' },
      { keys: 'Escape', description: 'Close modal/dropdown' },
    ],
  },
];

const KeyboardShortcutsHelp = ({ isOpen, onClose }) => (
  <Modal isOpen={isOpen} onClose={onClose} title="Keyboard Shortcuts" size="lg">
    <div className="p-4 space-y-6">
      {SHORTCUTS.map(({ category, items }) => (
        <div key={category}>
          <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">
            {category}
          </h3>
          <div className="space-y-2">
            {items.map(({ keys, description }) => (
              <div key={keys} className="flex items-center justify-between py-1.5">
                <span className="text-sm text-gray-700 dark:text-gray-300">{description}</span>
                <kbd className="px-2 py-1 text-xs font-sans bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded text-gray-600 dark:text-gray-300">
                  {getShortcutLabel(keys)}
                </kbd>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </Modal>
);

export default KeyboardShortcutsHelp;
